var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar",attrs:{"id":"navbar"}},[_c('div',{staticClass:"nav-btn",on:{"click":_vm.toggleSideBar}},[_c('svg-icon',{attrs:{"icon-class":"nav"}}),_vm._v(" 导航 ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }